/**
 *  Function to make ajax call
 *   @param {object} requestObj -
 *   {
 *       'method': 'GET'
 *       'url': 'https://autosug.qa.ebay.com/autosug?_dg=0&sId=0&callback=0&kwd=i',
 *       'responseType': 'json',
 *      'body': { value: 1 }
 *      'headers': { Authorization: 'Bearer xxxx' }
 *   }
 *   @param {object} callBacks -
 *   {
 *       'successCallBack': function(data){},
 *       'errorCallBack': function(textStatus){}
 *   }
 *   @param {number} [timeout] - timeout for the request
 **/
export const ajax = (requestObj, callBacks, timeout) => {
    const fullRequest = { ...requestObj, ...callBacks, timeout };
    if (window.fetch) {
        fetchHandler(fullRequest);
    } else {
        xhrHandler(fullRequest);
    }
};

function fetchHandler(requestObj) {
    const {
        url,
        body,
        headers = {},
        timeout,
        method = 'GET',
        responseType = 'json',
        successCallBack = () => {},
        errorCallBack = () => {}
    } = requestObj;
    const controller = new AbortController();
    let timeoutCtrl;
    if (typeof timeout !== 'undefined') {
        timeoutCtrl = setTimeout(() => controller.abort(), timeout);
    }
    let parsedBody;
    if (body) {
        headers['Content-Type'] = 'application/json';
        parsedBody = JSON.stringify(body);
    }
    const reqObj = {
        method,
        headers,
        body: parsedBody,
        redirect: 'manual',
        signal: controller.signal
    };
    window.fetch(url, reqObj).then(async res => {
        if (res.ok) {
            let parsedResponse;
            switch (responseType) {
                case 'arraybuffer': parsedResponse = await res.arrayBuffer(); break;
                case 'blob': parsedResponse = await res.blob(); break;
                case 'form': parsedResponse = await res.formData(); break;
                case 'json': parsedResponse = await res.json(); break;
                default: parsedResponse = await res.text(); break;
            }
            successCallBack(parsedResponse);
        } else {
            if (res.type === 'opaqueredirect') {
                /**
                 * By design the redirect destination after a 3XX response is not provided
                 * doing a manual redirect will allow us to catch the type 'opaqueredirect'
                 * and after that make the request again with a FORM submission to get redirected
                 **/
                const form = document.createElement('form');
                document.body.appendChild(form);
                form.method = method;
                form.action = url;
                form.submit();
            } else {
                errorCallBack(res.statusText);
            }
        }
    }).catch(err => {
        errorCallBack(err.statusText);
    }).finally(() => {
        if (timeoutCtrl) clearTimeout(timeoutCtrl);
    });
}

// Fallback strategy
function xhrHandler(requestObj) {
    const {
        url,
        body,
        headers,
        timeout,
        method = 'GET',
        responseType = 'json',
        successCallBack = () => {},
        errorCallBack = () => {}
    } = requestObj;
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = requestObj.withCredentials;
    xhr.open(method, url);
    if (headers) {
        for (const header in headers) {
            if (headers.hasOwnProperty(header)) {
                xhr.setRequestHeader(header, headers[header]);
            }
        }
    }
    if (typeof timeout !== 'undefined') {
        xhr.timeout = timeout;
        xhr.ontimeout = () => {
            xhr.abort();
            errorCallBack(xhr.statusText);
        };
    }
    xhr.responseType = responseType;
    xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status <= 299) {
            successCallBack(xhr.response);
        } else {
            errorCallBack(xhr.response || xhr.statusText);
        }
    };
    xhr.onerror = () => {
        errorCallBack(xhr.response || xhr.statusText);
    };
    let parsedBody;
    if (body) {
        xhr.setRequestHeader('Content-Type', 'application/json');
        parsedBody = JSON.stringify(body);
    }
    xhr.send(parsedBody);
}
